import { render, staticRenderFns } from "./linkageShare.vue?vue&type=template&id=3e415d38&scoped=true"
import script from "./linkageShare.vue?vue&type=script&lang=js"
export * from "./linkageShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e415d38",
  null
  
)

export default component.exports